import { renderTimeline } from './modules/index';

// Solution courtesy of Stackoverflow user @hexalys
if (navigator.platform.substr(0, 2) === 'iP') {
  //iOS (iPhone, iPod or iPad)
  let lte9 = /constructor/i.test(window.HTMLElement);
  let nav = window.navigator;
  let ua = nav.userAgent;
  let idb = !!window.indexedDB;
  if (
    ua.indexOf('Safari') !== -1 &&
    ua.indexOf('Version') !== -1 &&
    !nav.standalone
  ) {
    // Do the thing only in iOS Safari, no other WKWebViews or UIWebViews
    renderTimeline();
  } else if ((!idb && lte9) || !window.statusbar.visible) {
    // UIWebView -- McClatchy iOS apps
    // If the apps switch to WKWebView this implementation won't work anymore
    $1('.header__video').remove();
    $1('.app__content').remove();
    $1('.app__intro').remove();
  } else if ((window.webkit && window.webkit.messageHandlers) || !lte9 || idb) {
    // WKWebView -- Renders for browser views like the Facebook iOS app
    renderTimeline();
  }
} else {
  // Do the thing everywhere else
  renderTimeline();
}
